import { useEffect, useState, useRef } from 'react';

export const useShowCtaAfterFold = (foldId: string, noHeader?: boolean) => {
    const [showCta, setShowCta] = useState(false);
    const wasVisibleRef = useRef(false);

    useEffect(() => {
        const foldEl = document.getElementById(foldId);
        if (!foldEl) return;

        const observer = new IntersectionObserver(
            ([entry]) => {
                const isVisible = entry.isIntersecting;
                const boundingTop = entry.boundingClientRect.top;

                // Only show CTA if it was previously visible and now it's above the screen
                if (!isVisible && boundingTop < 0 && wasVisibleRef.current) {
                    setShowCta(true);
                } else {
                    setShowCta(false);
                }

                wasVisibleRef.current = isVisible;
            },
            {
                threshold: noHeader ? 0 : 0.15,
            }
        );

        observer.observe(foldEl);

        return () => observer.disconnect();
    }, [foldId]);

    return showCta;
};
